module.exports = __webpack_public_path__ + "static/media/wave-square.9fb2b431.svg";